import { Component, Input, OnInit } from '@angular/core';

@Component({
    standalone: true,
    selector: 'checkout-mandatory-field',
    templateUrl: './mandatory-field.component.html',
    styleUrl: './mandatory-field.component.scss'
})
export class MandatoryFieldComponent implements OnInit {
    @Input() isPlural: boolean = true;
    public label: string = 'Champs obligatoires';

    ngOnInit(): void {
        this.label = this.isPlural ? 'Champs obligatoires' : 'Champ obligatoire';
    }

}
